import { ILucaWorkflowTool } from '@query'

export interface LucaToolGroup {
  category: string
  tools: ILucaWorkflowTool[]
}

export const humanizeLucaToolName = (name: string): string =>
  name
    .split('_')
    .filter(Boolean)
    .map((part, index) => (index === 0 ? `${part.charAt(0).toUpperCase()}${part.slice(1)}` : part))
    .join(' ')

export const groupLucaTools = (tools: ILucaWorkflowTool[]): LucaToolGroup[] => {
  const groups = new Map<string, ILucaWorkflowTool[]>()
  for (const tool of tools) {
    const category = tool.category || 'Other'
    groups.set(category, [...(groups.get(category) ?? []), tool])
  }
  return [...groups.entries()].map(([category, groupedTools]) => ({
    category,
    tools: groupedTools
  }))
}

export const filterLucaToolGroups = (groups: LucaToolGroup[], query: string): LucaToolGroup[] => {
  const normalizedQuery = query.trim().toLocaleLowerCase()
  if (!normalizedQuery) return groups

  return groups.flatMap(group => {
    if (group.category.toLocaleLowerCase().includes(normalizedQuery)) return [group]

    const tools = group.tools.filter(tool =>
      [tool.title, tool.name].some(value => value.toLocaleLowerCase().includes(normalizedQuery))
    )
    return tools.length > 0 ? [{ ...group, tools }] : []
  })
}

export const orderSelectedLucaTools = (
  selected: string[],
  catalogTools: ILucaWorkflowTool[]
): string[] => {
  const selectedSet = new Set(selected)
  const ordered = catalogTools.map(tool => tool.name).filter(name => selectedSet.has(name))
  const catalogNames = new Set(catalogTools.map(tool => tool.name))
  return [...ordered, ...selected.filter(name => !catalogNames.has(name))]
}
